import e,{css as i}from"styled-components";import{COLORS as o}from"../../constants/Theme.js";const r=e.div`
	display: inline-flex;
	gap: 8px;
	align-items: center;
	cursor: ${e=>e.isDisabled?"default":"pointer"};
	${e=>e.enableHover&&i`
			:hover {
				background: ${o.surface.subdued};
			}
		`}
`,s=e.div`
	width: ${e=>"SMALL"===e.size?12:14}px;
	height: ${e=>"SMALL"===e.size?12:14}px;
	border-radius: 4px;
	border: 2px solid black;
	display: flex;
	justify-content: center;
	align-items: center;
	box-sizing: content-box;
	${e=>{var r;return e.isDisabled?i`
					border: ${"SMALL"===e.size?1.5:2}px solid
						${o.content.inactive};
			  `:i`
					border: ${"SMALL"===e.size?1.5:2}px solid
						${null!==(r=e.borderColor)&&void 0!==r?r:"black"};
			  `}}
	${e=>e.checked&&i`
			border: 0px;
			width: 18px;
			height: 18px;
		`}
	${e=>e.hovered&&i`
			outline: 3px solid ${o.surface.hovered};
		`}
	${e=>e.clicked&&!e.isDisabled&&i`
			outline: 3px solid
				${e.checked?o.stroke.positive.lightAlt:o.surface.hovered};
			outline-offset: 2px;
		`}
`;export{r as CheckboxContainer,s as CheckboxIcon};
